import React, { useState } from 'react';
import { DISMISS_REASONS, CONFIDENCE_LEVELS } from '../../utils/recommendations';

/** Dismissal requires a reason (builds the override dataset described in the design doc). */
const DismissRecommendationModal = ({ rec, onClose, onConfirm }) => {
  const [reasonCode, setReasonCode] = useState('');
  const [reason, setReason] = useState('');
  const [confidence, setConfidence] = useState('strong');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const needsText = reasonCode === 'other';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reasonCode) return setError('Please choose a reason.');
    if (needsText && !reason.trim()) return setError('Please describe the reason.');
    setSaving(true);
    setError('');
    try {
      await onConfirm({ reasonCode, reason, confidence });
    } catch (err) {
      setError(err.message || 'Failed to dismiss.');
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4">
      <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
        <h3 className="text-lg font-bold text-gray-900">Dismiss recommendation</h3>
        <p className="text-sm text-gray-600 mt-1 break-words">{rec.title}</p>

        <label className="block text-sm font-medium text-gray-700 mt-4">Reason <span className="text-red-500">*</span></label>
        <select value={reasonCode} onChange={e => setReasonCode(e.target.value)} className="w-full border border-gray-300 rounded px-3 py-2 mt-1">
          <option value="">Select a reason…</option>
          {DISMISS_REASONS.map(r => <option key={r.code} value={r.code}>{r.label}</option>)}
        </select>

        <label className="block text-sm font-medium text-gray-700 mt-4">
          Details {needsText && <span className="text-red-500">*</span>}
        </label>
        <textarea
          value={reason}
          onChange={e => setReason(e.target.value)}
          maxLength={500}
          rows={3}
          className="w-full border border-gray-300 rounded px-3 py-2 mt-1"
          placeholder="Optional context that helps improve future recommendations"
        />

        <fieldset className="mt-4">
          <legend className="text-sm font-medium text-gray-700">How confident are you?</legend>
          <div className="flex flex-wrap gap-4 mt-1">
            {CONFIDENCE_LEVELS.map(c => (
              <label key={c.value} className="flex items-center gap-2 text-sm">
                <input type="radio" name="confidence" value={c.value} checked={confidence === c.value} onChange={() => setConfidence(c.value)} />
                {c.label}
              </label>
            ))}
          </div>
        </fieldset>

        {error && <p className="text-sm text-red-600 mt-3">{error}</p>}

        <div className="flex justify-end gap-2 mt-6">
          <button type="button" onClick={onClose} className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-50">Cancel</button>
          <button type="submit" disabled={saving} className="px-4 py-2 rounded bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-50">
            {saving ? 'Saving…' : 'Dismiss'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default DismissRecommendationModal;
